<template>
    <section class="default-two-columns">
      <div class="container-fluid">
        <div class="default-two-columns--row">
          <div class="default-first-column">
            <div v-if="mobile" class="category-mobile-description">
              <h1 class="default-title">{{manufacturerCurent.name}}</h1>
              <div class="product-list--description" v-html="manufacturerCurent.description"></div>
            </div>
            <div class="category-filters" :class="{active: filters && mobile}">
              <div v-if="mobile" @click="filters = !filters" class="category-filters--dropdown">
                <svg class="svg-sprite-icon svg-sprite-unstyled icon-filters">
                  <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-filters"></use>
                </svg>
                Filters
                <svg v-if="filters" class="svg-sprite-icon svg-sprite-unstyled icon-close">
                  <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-close"></use>
                </svg>
              </div>
              <div class="category-filters--content" v-show="filters || !mobile">
                <div class="product-categories">
                  <div class="dropdown-title">
                    Manufacturers
                    <!-- <svg class="svg-sprite-icon svg-sprite-unstyled icon-title-hide">
                      <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-title-hide"></use>
                    </svg> -->
                  </div>
                  <div class="product-categories--list">
                    <div class="product-categories--item" v-for="(manufacturer, index) in manufacturers" v-bind:key="index">
                      <a :href="manufacturer.id" class="product-categories--link" v-bind:class="(manufacturer.id === manufacturerCurent.id) ? 'active' : '' ">
                        {{manufacturer.name}}
                      </a>
                    </div>
                  </div>
                  <!-- <nuxt-link to="#" class="dropdown-view-more">
                    <span class="dropdown-view-more--icon">+</span> All
                  </nuxt-link> -->
                </div>
                <div class="aside-divider"></div>
                <div class="aside-divider"></div>
                <!-- <div class="manufacturer-filter">
                  <div class="dropdown-title">
                    Manufacturer
                    <svg class="svg-sprite-icon svg-sprite-unstyled icon-title-show">
                      <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-title-show"></use>
                    </svg>
                  </div>
                  <div class="brand-filter--list">
                    <div class="brand-filter--item" v-for="(manufacterer, index) in manufacturers" v-bind:key="index">
                      <label class="cs-checkbox">
                        <input class="cs-checkbox--input" type="checkbox" v-model="selected_manufacturers" :value="manufacterer.id">
                        <div class="cs-checkbox--visible">
                          <svg class="svg-sprite-icon svg-sprite-unstyled icon-check">
                            <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-check"></use>
                          </svg>
                        </div>
                        <div class="cs-checkbox--text">{{manufacterer.name}}</div>
                        <div class="cs-checkbox--count">{{manufacterer.products_count}}</div>
                      </label>
                    </div>
                  </div>
                </div> -->
                <div>
                    <button class="category-filters--button category-filters--button-clear" v-on:click="clear">Clear</button>
                    <button class="category-filters--button category-filters--button-apply" v-on:click="fetch">Apply</button>
                </div>
                <div v-if="mobile" class="category-filters--buttons">
                  <button class="category-filters--button category-filters--button-clear" v-on:click="clear">Clear</button>
                  <button class="category-filters--button category-filters--button-apply" v-on:click="fetch">Apply</button>
                </div>
              </div>
            </div>
          </div>
          <div class="default-second-column">

            <div class="product-list">
              <template v-if="!mobile">
                <h1 class="default-title">{{manufacturerCurent.name}}</h1>
                <div class="product-list--description" v-html="manufacturerCurent.description"></div>
              </template>
              <div class="product-list--grid">
                  <div class="product-list--filters">
                    <select class="cs-select product-list--filters-sort" v-model="order_by">
                      <option :value="['created_at', 'desc']" selected>Sort by latest</option>
                      <option :value="['created_at', 'asc']">Sort by newest</option>
                      <!-- <option value="2">Sort by price (low to high)</option> -->
                    </select>
                    <div class="product-list--filters-show">
                      Showing {{from}}–{{to}} of {{total}} results
                    </div>
                    <div class="product-list--filters-view">
                      <svg @click="rows = false" :class="{active: !rows}" class="svg-sprite-icon svg-sprite-unstyled icon-view-columns">
                        <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-view-columns"></use>
                      </svg>
                      <svg @click="rows = true" :class="{active: rows}" class="svg-sprite-icon svg-sprite-unstyled icon-view-rows">
                        <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-view-rows"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="product-list--wrapper" :class="{'product-list--wrapper-columns': !rows,'product-list--wrapper-rows': rows}">
                      <template v-for="(product, index) in products.data">
                        <a v-bind:href="productUrl + '/' + product.id" class="product-list--product" v-bind:key="index">
                            <img :src="'/upload/' + product.image" alt="" class="product-list--img">

                            <div class="product-list--info">
                                <div class="product-list--title">{{product.title}}</div>
                                <div v-if="rows" class="product-list--info-row">
                                <div class="product-list--info-col">
                                    <div class="product-list--info-key">Format:</div>
                                    <div class="product-list--info-val" v-html="product.format"></div>
                                    <div class="product-list--info-note" v-html="product.info_note"></div>
                                </div>
                                <div class="product-list--info-col">
                                    <div class="product-list--info-key">Use for:</div>
                                    <div class="product-list--info-desc" v-html="product.use_for"></div>
                                </div>
                                </div>
                            </div>
                            <div class="product-list--favourite-rel">
                                <div class="product-list--favourite" v-on:click.prevent="addToFavorites(product.id)">
                                    <template v-if="isInclude(product.id)">
                                        <svg class="svg-sprite-icon svg-sprite-unstyled icon-hearth-fill">
                                            <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-hearth-fill"></use>
                                        </svg>
                                        <span class="product-list--favourite-text">Remove from wishlist</span>
                                    </template>
                                    <template v-else>
                                        <svg class="svg-sprite-icon svg-sprite-unstyled icon-hearth">
                                            <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-hearth"></use>
                                        </svg>
                                        <span class="product-list--favourite-text">Add to wishlist</span>
                                    </template>
                                </div>
                            </div>
                        </a>
                      </template>
                  </div>

                  <div class="mt-34 b-pagination">
                    <pagination :data="products" @pagination-change-page="fetch" :limit="1" :show-disabled="true">
                        <span slot="prev-nav">
                            <svg class="svg-sprite-icon svg-sprite-unstyled icon-category-arrow">
                                <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-category-arrow"></use>
                            </svg>
                        </span>
                        <span slot="next-nav">
                            <svg class="svg-sprite-icon svg-sprite-unstyled icon-category-arrow">
                                <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-category-arrow"></use>
                            </svg>
                        </span>
                    </pagination>
                  </div>
                </div>
            </div>

          </div>
        </div>
      </div>
    </section>
</template>

<script>
    import pagination from 'laravel-vue-pagination'
    export default {
        components: {
            pagination
        },
        props: {
            manufacturer: {
                type: Object
            },
            manufacturersUrl: {
                type: String,
                required: false
            },
            productsUrl: {
                type: String,
                required: false
            },
            productUrl: {
                type: String,
                required: false
            },
        },
        data: () => ({
            page: 1,
            total: 0,
            from: 0,
            to: 0,
            per_page: 12,
            rows: false,
            filters: false,
            mobile: false,
            loading: false,
            manufacturerCurent: {},
            manufacturers: [],
            products: {},
            order_by: ['created_at', 'desc'],
            show_brands_more: 3,
            favorites_products: []
        }),

        methods: {
            filter() {
                this.fetch();
            },

            fetch(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                this.page = page;
                this.loading = true;
                axios.get(this.productsUrl, {
                    params: {
                        page: this.page,
                        per_page: this.per_page,
                        manufacturer_id: this.manufacturer.id,
                        order_by: this.order_by,
                    }
                }).then((res) => {
                        // console.log('products');
                        // console.log(res.data);
                        this.total = res.data.meta.total;
                        this.from = res.data.meta.from;
                        this.to = res.data.meta.to;
                        this.products = res.data;
                        this.loading = false;
                        // this.getFavorites();
                    });
            },
            fetchData() {
                this.loading = true;
                axios.get(this.manufacturersUrl + '/' + this.manufacturer.id, {
                    params: {
                        page: 1,
                    }
                }).then((res) => {
                  // console.log(res);
                  this.manufacturerCurent = res.data;
                });

                // axios.get(this.categoryUrl)
                //     .then((res) => {
                //     this.categories = res.data;
                // });

                // axios.get(this.categoryUrl + '/brands/' + this.category.id)
                // .then((res) => {
                //     this.brands = res.data;
                // });

                axios.get(this.manufacturersUrl)
                .then((res) => {
                    // console.log(res.data);
                    this.manufacturers = res.data;
                });

            },
            clear() {
                window.location.reload();
            },
            resize() {
                this.mobile =  window.innerWidth < 1101 ? true : false;
            },
            more_brands() {
                if(this.show_brands_more == this.brands.length) {
                    this.show_brands_more = 3
                }else {
                    this.show_brands_more = this.brands.length;
                }
            },
            addToFavorites(product) {
                let products = JSON.parse(localStorage.getItem("products"));
                console.log(products);
                if(products !== null){
                    console.log(typeof(products));
                    if (products.hasOwnProperty(product)) {
                        delete products[product];
                    }else {
                        products[product] = 1;
                    }
                    localStorage.setItem("products", JSON.stringify(products));
                } else{
                    products = {
                        [product]: 1
                    }
                    localStorage.setItem("products", JSON.stringify(products));
                }
                this.getFavorites();
            },
            getFavorites() {
                let products = JSON.parse(localStorage.getItem("products"));
                let favorites_keys = Object.keys(Object.assign({}, products));
                let res = favorites_keys.map(function(item) {
                    return parseInt(item);
                });
                this.favorites_products = res;
            },
            isInclude(product) {
                if(this.favorites_products.length) {
                    return this.favorites_products.includes(product);
                }
                return false;
            }
        },

        mounted() {
            this.resize();
            window.addEventListener('resize', this.resize)
            this.fetch();
            this.fetchData();
            this.getFavorites();
        },
        destroyed() {
            window.removeEventListener('resize', this.resize)
        },
        watch: { 
            order_by: function(newVal, oldVal) { // watch it
                this.fetch();
            }
        }
    }
</script>
